module.exports = __webpack_public_path__ + "images/interview-NVIDA-2.svg";